export default __webpack_public_path__ + "static/media/4837.479fe9fb.png";